import React from 'react';

const skeleton = (): JSX.Element => {
    return <span className='msc-skeleton'>&zwnj;</span>;
};

export default skeleton;
